import { initializeCart } from '../updateCart';

export default class Bundles {
    constructor() {
        this.MAX_PRODUCTS = 5;
        this.currentProducts = 0;
        this.selectedProducts = [];
        this.summerBundleElement = document.querySelector('.bundle-summary');
        this.bundleProducts = document.querySelectorAll('.buddle-products .product-item');
        this.productType = document.querySelector('.sort-product-type');
        this.summaryTable = document.querySelector('.bundle-products-table-holder');
        this.appliedDiscountElement = document.querySelector('.applied-discount strong');
        this.additionalDiscountsElement = document.querySelector('.additional-discounts');
        this.submitBtn = this.summerBundleElement.querySelector('.summary-actions button');
        this.clearProducts = this.summerBundleElement.querySelector('.summary-actions .clear-kit');
        this.mobileKitElement = document.querySelector('.mobile-kit');

        if(this.bundleProducts) {
            this.bundleProducts.forEach(item => {
                const modalButton = item.querySelector('.quick-view button');
                item.addEventListener('click', e => {
                    e.preventDefault();
                    modalButton.click();
                })
            })
        }

        if(this.productType) {
            this.productType.addEventListener('click', (e) => {
                e.stopPropagation();
                this.openSortContainer(e.target);
            })
        }

        if(this.submitBtn) {
            this.submitBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.submitOrderBundle();
            })
        }

        if(this.clearProducts){
            this.clearProducts.addEventListener('click', (e) => {
                e.preventDefault();
                this.currentProducts = 0;
                this.selectedProducts = [];
                this.updateSummary();
            })
        }

        if(this.mobileKitElement){
            const self = this;
            this.mobileKitElement.addEventListener('click', function() {
              console.log('mobileKitElement bundles')
                this.classList.toggle('active');
                self.summerBundleElement.classList.toggle('active');
            })
        }

        this.scrollToSection();

        document.querySelectorAll('.options-container > div').forEach((item) => {
            item.addEventListener('click', function(){
                this.closest('.options-container').classList.remove('show');
            })
        })

        document.querySelectorAll('.product-form--submit-bundle').forEach((item) => {
            const self = this;
            item.addEventListener('click', function(e) {
                e.preventDefault();
                const modal = this.closest('.modal');
                const modalButton = modal.querySelector('.close-modal');

                if(self.currentProducts >= self.MAX_PRODUCTS){
                    alert(`Max ${self.MAX_PRODUCTS} products can be added to a kit!`)
                    return;
                }

                const container = this.closest('.product-hero-container');
                const select = container.querySelector('[name="id"]');
                const image = container.querySelector('.hero-selected-img').getAttribute('data-src');
                const price = select.selectedOptions[0].getAttribute('data-price');
                const title = select.selectedOptions[0].getAttribute('data-title');
                self.selectedProducts.push({
                    id: select.value,
                    image: image,
                    qty: 1,
                    price: parseInt(price),
                    title: title
                });

                self.currentProducts = self.currentProducts + 1;
                self.mobileKitElement.classList.add('bounce');
                setTimeout(function(){
                    self.mobileKitElement.classList.remove('bounce');
                }, 1000)
                self.updateSummary();

                modalButton.click();
                // Close quickview modal
                modal.classList.add('out');

                setTimeout(() => {
                    modal.style.display = 'none';
                    modal.classList.remove('out');
                }, 250);
            })
        })
    }

    /**
     * Handle summary content markup update
     *
     * @return  {void}
     */
    updateSummary(){
        this.summaryTable.innerHTML = this.createBundleTable();
        if(this.currentProducts > 0){
            this.addRemoveClickEvents();
            this.appliedDiscountText();
            this.additionalDiscounts();
        } else {
            this.appliedDiscountElement.innerHTML = '';
            this.additionalDiscountsElement.innerHTML = `<p>${bundleScripts.discount_text}</p>`;
        }
        this.updateSubmitBtn();
    }

    /**
     * Update add to cart button price and visability
     *
     * @return  {vodi}
     */
    updateSubmitBtn() {
        if(this.currentProducts > 1){
            this.submitBtn.classList.remove('no-discount');
            this.submitBtn.classList.remove('hidden');
            this.clearProducts.classList.remove('hidden');
        } else if (this.currentProducts == 1) {
            this.submitBtn.classList.add('no-discount');
            this.submitBtn.classList.remove('hidden');
            this.clearProducts.classList.remove('hidden');
        } else {
            this.submitBtn.classList.add('hidden');
            this.clearProducts.classList.add('hidden');
            return;
        }

        const currentDiscount = bundleScripts.discounts.filter(item => item.qty === this.currentProducts).pop().percent / 100;
        const totalPrice = this.selectedProducts.reduce((acc, val) => acc + val.price*val.qty,0);
        const totalPriceDiscount = totalPrice - (totalPrice*currentDiscount);
        const totalPriceMoney = this.formatMoney(totalPrice, Shopify.money_format);
        const totalPriceDiscountMoney = this.formatMoney(totalPriceDiscount, Shopify.money_format);

        // this.submitBtn.querySelector('s').innerText = totalPriceMoney;
        // this.submitBtn.querySelector('span').innerText = totalPriceDiscountMoney;
    }

    /**
     * Add remove events for the summary links
     *
     * @return  {void}  [return description]
     */
    addRemoveClickEvents(){
        const self = this;
        self.summaryTable.querySelectorAll('.remove-product').forEach((item) => {
            item.addEventListener('click', function(e){
                e.preventDefault();
                self.selectedProducts = self.selectedProducts.filter((_,ind) => ind !== parseInt(item.closest('tr').getAttribute('data-index')));

                self.currentProducts = self.currentProducts - 1;
                self.updateSummary();
            })
        })
    }

    /**
     * Format money from cents to currency
     *
     * @param   {Int}  cents
     * @param   {String}  format
     *
     * @return  {String}
     */
    formatMoney(cents, format) {
        if (typeof cents == 'string') { cents = cents.replace('.',''); }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || this.money_format);

        function defaultOption(opt, def) {
           return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal   = defaultOption(decimal, '.');

          if (isNaN(number) || number == null) { return 0; }

          number = (number/100.0).toFixed(precision);

          var parts   = number.split('.'),
              dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              cents   = parts[1] ? (decimal + parts[1]) : '';

          return dollars + cents;
        }

        switch(formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        }

        return formatString.replace(placeholderRegex, value);
    };


    /**
     * Create the tablet markup
     *
     * @return  {String}  [return description]
     */
    createBundleTable(){
        let dummyRows = '';
        if(this.selectedProducts.length < 5){
            for (let index = 0; index < 5 - this.selectedProducts.length; index++) {
                dummyRows += `
                    <tr>
                        <td><div style="height: 40px;"></div></td>
                        <td><div style="height: 40px;"></div></td>
                        <td><div style="height: 40px;"></div></td>
                        <td><div style="height: 40px;"></div></td>
                    </tr>
                `

            }
        }
        return `<table class="bundle-products-table">
            <tbody>
                ${this.selectedProducts.map((item, ind) => (
                    `<tr data-index="${ind}">
                        <td>
                            <a href="#" class="remove-product" data-variant-id="${item.id}" data-qty="${item.qty}">X</a>
                        </td>
                        <td>
                            <span class="img-holder"><img src="${item.image}" /></span>
                        </td>
                        <td>
                            ${item.title} ${item.qty > 1 ? 'x' + item.qty : ''}
                        </td>
                        <td>
                            ${this.formatMoney(item.price*item.qty, Shopify.money_format)}
                        </td>
                    </tr>`
                )).join('')}
                ${dummyRows}
            </tbody>
        </table>`
    }

    /**
     * Convert number to word
     *
     * @param   {Integer}  num
     *
     * @return  {String}
     */
    humanize(num){
        const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
                    'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen',
                    'seventeen', 'eighteen', 'nineteen'];
        const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty',
                    'ninety'];

        const numString = num.toString();

        if (num < 0) throw new Error('Negative numbers are not supported.');

        if (num === 0) return 'zero';

        //the case of 1 - 20
        if (num < 20) {
          return ones[num];
        }

        if (numString.length === 2) {
          return tens[numString[0]] + ' ' + ones[numString[1]];
        }

        //100 and more
        if (numString.length == 3) {
          if (numString[1] === '0' && numString[2] === '0')
            return ones[numString[0]] + ' hundred';
          else
            return ones[numString[0]] + ' hundred and ' + humanize(+(numString[1] + numString[2]));
        }

        if (numString.length === 4) {
          const end = +(numString[1] + numString[2] + numString[3]);
          if (end === 0) return ones[numString[0]] + ' thousand';
          if (end < 100) return ones[numString[0]] + ' thousand and ' + humanize(end);
          return ones[numString[0]] + ' thousand ' + humanize(end);
        }
    }

    /**
     * Get offest top
     *
     * @param   {Node}  el
     *
     * @return  {Object}
     */
    getOffset( el ) {
        let _x = 0;
        let _y = 0;
        while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
            _x += el.offsetLeft - el.scrollLeft;
            _y += el.offsetTop - el.scrollTop;
            el = el.offsetParent;
        }
        return { top: _y, left: _x };
    }

    /**
     * Open product filter dropdown
     *
     * @param   {Node}  target
     *
     * @return  {void}
     */
    openSortContainer(target) {
        if(!target.classList.contains('sort-product-type')){
            return;
        }
        const sortContainer = target.querySelector('.sort-container');
        const panelHeight = sortContainer.style.maxHeight;

        if (!panelHeight || panelHeight === '0px') {
            target.classList.add('opened');
            sortContainer.style.maxHeight = sortContainer.scrollHeight + 'px';
        } else {
            this.closeSortContainer(target);
        }
    }

    /**
     * Close product type dropdown
     *
     * @param   {Node}  target
     *
     * @return  {vodi}
     */
    closeSortContainer(target) {
        const sortContainer = target.querySelector('.sort-container');
        target.classList.remove('opened');
        sortContainer.style.maxHeight = '0px';
    }

    /**
     * Scroll to product type section
     *
     * @return  {vodi}
     */
    scrollToSection(){
        document.querySelectorAll('.sort-product-type li').forEach(item => {
            item.addEventListener('click', (e) => {
                e.stopPropagation();
                const dataTarget = item.getAttribute('data-target');
                const ele = document.querySelector(dataTarget);
                const offsetTop = this.getOffset(ele).top - ele.clientHeight - 20;
                window.scrollTo({
                    behavior: 'smooth',
                    top: offsetTop
                })

                this.closeSortContainer(this.productType);
            })
        })
    }

    /**
     * Add current applied text discount
     *
     * @return  {void}
     */
    appliedDiscountText(){
        if(this.currentProducts > 1) {
            const percent = bundleScripts.discounts.filter(item => item.qty === this.currentProducts).pop().percent;
            const text = translatableStrings.applied_discount.replace('[num]', percent);
            this.appliedDiscountElement.textContent = text;
        } else {
            this.appliedDiscountElement.innerHTML = '';
        }
    }

    setCartAttribute(){
        fetch('/cart/update.js', {
            method: "post",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify({
                attributes: {
                    byok: "true"
                }
            })
        })
    }

    /**
     * Add additional discounts text
     *
     * @return  {vodi}
     */
    additionalDiscounts(){
        this.additionalDiscountsElement.innerHTML = '';
        for (let index = 0; index < this.MAX_PRODUCTS - this.currentProducts; index++) {
            const loop1 = index + 1;
            const productText = loop1 > 1 ? 'products' : 'product';
            const currentPercent = bundleScripts.discounts.filter(item => item.qty === this.currentProducts).pop().percent;
            const nextPercent = bundleScripts.discounts.filter(item => item.qty === this.currentProducts + loop1).pop().percent;
            const diff =  nextPercent - currentPercent;
            const text = translatableStrings.add_product_text.replace("[num]", this.humanize(loop1)).replace('[product]', productText).replace('[diff]', nextPercent)
            this.additionalDiscountsElement.insertAdjacentHTML('beforeend', `<p>${text}</p>`)
            break;
        }
    }

    /**
   * Handle bundle submit
   * @return  {void}
   */
  submitOrderBundle() {
    let properties = {}
    if(this.submitBtn.getAttribute('data-db') === 'false') {
      properties['__hash']  = new Date().getTime();
      properties['__discounted']  = true;
      properties['__hidden']  = true;
    }

    this.selectedProducts = this.selectedProducts.reduce((acc, val) => {
        const hasProduct = acc.filter(item => item.id === val.id);
        if(hasProduct.length){
            acc = acc.map(item => {
                if(item.id === val.id){
                    item.qty = item.qty + 1;
                }
                return item;
            })
        } else {
            acc.push(val);
        }
        return acc;
    },[])

    const kitProducts = this.selectedProducts.map((item) => ({
        quantity: item.qty,
        id: item.id,
        properties: properties
    }))

    const productQty = this.selectedProducts.reduce((acc, val) => {
        acc += val.qty;
        return acc;
    }, 0);

    if(window.giftProductID && productQty > 1) {
        console.log('added gift');
        kitProducts.push({
            quantity: 1,
            id: window.giftProductID,
            properties: {
                __hash: new Date().getTime(),
                __hidden: true,
                __gift: true
            }
        })
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: kitProducts
      })
    })
      .then((res) => {
        if (res.ok) return res.json();
        else throw Error(`Request rejected with status ${res.status}`);
      })
      .then((res) => {
        this.currentProducts = 0;
        this.selectedProducts = [];
        this.updateSummary();
        this.setCartAttribute();
        this.mobileKitElement.classList.remove('active');
        this.summerBundleElement.classList.remove('active');
        initializeCart();
        document.body.classList.add('cart-open');
        document.getElementById('shopify-section-cart').classList.add('show');
      })
      .catch(console.log);
  }
}
